const initialState = {
  total: 0,
};
const TotalAnnualSalesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_TOTAL_ANNUAL_SALES":
      if (action.payload !== undefined) {
        return (initialState.total = action.payload);
      }
      break;
    default:
      return state;
  }
};

export default TotalAnnualSalesReducer;
